import styled from "styled-components";
import CodeDetailModel from "./model";

const CodeDetail = styled(CodeDetailModel)`
  #root & {
  }
`;

export default CodeDetail;
